import { useQuery } from 'react-query'
import { getCalendarEventsForJob } from './calendarEventsApi'

export const useCalendarEventsForJob = (jobId: number, enabled: boolean) => {
  return useQuery(['calendar-events', 'job', jobId], {
    queryFn: () => getCalendarEventsForJob(jobId),
    enabled
  })
}
